import React from 'react';
import PropTypes from 'prop-types';
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import Button from "../components/Button";

const InputSearchWithButton = props => {
  const inputRef = React.createRef()
  const [value, setValue] = React.useState(props.value);

  const handleOnKeyUp = (e) => {
    switch (e.key) {
      case 'Enter': {
        props.onInputChanged(value)
        return;
      }
      case 'Escape': {
        setValue('');
        props.onInputChanged('')
        return;
      }
      default: {

      }
    }

    setValue(e.target.value);
  }

  return (
    <InputGroup className="d-flex flex-nowrap">
      <Input
        autoFocus={props.autoFocus}
        innerRef={inputRef}
        role="table-input-search"
        placeholder={props.placeholder}
        style={{width: '120px'}}
        onKeyUp={handleOnKeyUp}
        onChange={e => setValue(e.target.value)}
        value={value}
      />
      <InputGroupAddon addonType="append" onClick={() => props.onInputChanged(value)}>
        <Button color="primary" className="m-0"><i className="fa fa-search" /></Button>
      </InputGroupAddon>
    </InputGroup>
  );
};

InputSearchWithButton.defaultProps = {
  autoFocus: false,
  placeholder: 'Wpisz treść...',
  value: '',
};
InputSearchWithButton.propTypes = {
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  onInputChanged: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default InputSearchWithButton;